import React, {Component} from 'react';
import CheckinDebugBtn from './CheckinDebugBtn';
import CheckinBlock from './CheckinBlock';
import CheckinBlockWithCheckout from './CheckinBlockWithCheckout';
import {fetchSessionConfig} from 'actions/UserActions';
import {fetchCheckinInfo} from 'actions/CheckinActions';
import WorkerNavBar from 'components/WorkerNavBar';

const UpcomingInlineRecord = ({label, siteName}) => (
  <div className="up-coming__record row">
    <div className="shift-label col-xs-4">
      <span className="label label-primary">{label}</span>
    </div>
    <div className="site-name col-xs-8">
      {siteName}
    </div>
  </div>
)

class Checkin extends Component {
  componentDidMount() {
    let {dispatch} = this.props;

    dispatch(fetchSessionConfig());
    dispatch(fetchCheckinInfo());    
  }

  render() {
    let {dispatch, current, upcoming, sessionConfig} = this.props;
    let currentRecords = current.get('records');
    let date = current.get('date');
    let [currentMorn, currentAftn, currentOt] = currentRecords;
    let upcomingRecords = upcoming.get('records');
    let [upcomingMorn, upcomingAftn, upcomingOt] = upcomingRecords;
    let [mornConfig, aftnConfig, otConfig] = sessionConfig;

    return (
      <div className="checkin">
        <WorkerNavBar />
        <div className="checkin__header">
        </div>
        {(date === 'xxxx-xx-xx')?
          <div className="loading">
            <h1>加載中...</h1>
          </div>
        :
          <div>
            {/*
              Morning shift checkin block
            */}
            <CheckinBlockWithCheckout label="上午" sid={0} date={date} sessionConfig={mornConfig} record={currentMorn} dispatch={dispatch} />

            {/*
              Aftnoon shift checkin block
            */}
            <CheckinBlockWithCheckout label="下午" sid={1} date={date} sessionConfig={aftnConfig} record={currentAftn} dispatch={dispatch} />

            {/*
              OverTime shift checkin block
            */}
            <CheckinBlockWithCheckout label="加班" sid={2} date={date} sessionConfig={otConfig} record={currentOt} dispatch={dispatch} />

            <div className="up-coming container">
              <div className="up-coming__header">
                <label>明天日程 ({upcoming.get('date')})</label>
              </div>

              <UpcomingInlineRecord label="上午" siteName={upcomingMorn} />
              <UpcomingInlineRecord label="下午" siteName={upcomingAftn} />
              <UpcomingInlineRecord label="加班" siteName={upcomingOt} />
            </div>

            <div style={{
              margin: '50px',
              textAlign: 'center'
            }}>            
              <CheckinDebugBtn />
            </div>
          </div>
        }
      </div>
    )
  }
}

export default Checkin;



// WEBPACK FOOTER //
// ./src/components/Checkin/Checkin.js